import WindowLayer from './WindowLayer';
import Confirm from './Confirm';

function confirm ({...params}) {
    params.btn = params.btn || ['确定', '取消'];
    params.component = params.component || Confirm;
    WindowLayer.open({
        ...params,
        extra: {message: params.message}
    });
}

const dialog = {
    open: WindowLayer.open,
    confirm
};

export default {
    install (Vue) {
        Object.defineProperty(Vue.prototype, '$dialog', {value: dialog});
    }
};



// WEBPACK FOOTER //
// ./src/widget/dialog/DialogPlugin.js